const TEXT = {
  ko: {
    promotionTitle: 'GNEGNEGNE를 앱으로 추가하세요',
    promotionBody: '홈 화면에서 더 빠르게 열고 일정 알림을 안정적으로 받아보세요.',
    installNow: '앱으로 추가',
    viewGuide: '추가 방법 보기',
    later: '나중에',
    alreadyInstalled: '이미 추가했어요',
    installing: '설치 창 여는 중…',
    guideTitle: 'GNEGNEGNE 앱 설치',
    guideIntro: '기기에 맞는 방법으로 홈 화면에 추가하면 일반 앱처럼 실행할 수 있습니다.',
    iosSafariTitle: 'iPhone · Safari',
    iosSafariSteps: ['Safari 하단의 공유 버튼을 누릅니다.', '홈 화면에 추가를 선택합니다.', '웹 앱으로 열기를 켭니다.', '오른쪽 위의 추가를 누릅니다.'],
    iosOtherNotice: 'iPhone에서는 이 페이지를 Safari로 연 뒤 아래 순서대로 추가해주세요.',
    androidTitle: 'Android · Chrome',
    androidSteps: ['Chrome 메뉴(⋮)를 엽니다.', '앱 설치 또는 홈 화면에 추가를 선택합니다.', '설치를 확인합니다.'],
    desktopTitle: '컴퓨터 브라우저',
    desktopSteps: ['주소창의 설치 아이콘 또는 브라우저 메뉴를 엽니다.', 'GNEGNEGNE 설치를 선택합니다.', '설치를 확인합니다.'],
    back: '돌아가기',
    settingsTitle: '앱 설치 안내',
    settingsDescription: '이 웹앱을 홈 화면이나 컴퓨터에 추가하는 방법을 확인합니다.',
    openGuide: '설치 방법 보기'
  },
  en: {
    promotionTitle: 'Add GNEGNEGNE as an app',
    promotionBody: 'Open it faster from your Home Screen and receive schedule notifications more reliably.',
    installNow: 'Install app',
    viewGuide: 'View instructions',
    later: 'Later',
    alreadyInstalled: 'Already installed',
    installing: 'Opening install prompt…',
    guideTitle: 'Install the GNEGNEGNE app',
    guideIntro: 'Add this web app to your device to open it like a regular app.',
    iosSafariTitle: 'iPhone · Safari',
    iosSafariSteps: ['Tap the Share button in Safari.', 'Choose Add to Home Screen.', 'Turn on Open as Web App.', 'Tap Add in the top-right corner.'],
    iosOtherNotice: 'On iPhone, open this page in Safari and then follow the steps below.',
    androidTitle: 'Android · Chrome',
    androidSteps: ['Open the Chrome menu (⋮).', 'Choose Install app or Add to Home screen.', 'Confirm the installation.'],
    desktopTitle: 'Desktop browser',
    desktopSteps: ['Open the install icon in the address bar or the browser menu.', 'Choose Install GNEGNEGNE.', 'Confirm the installation.'],
    back: 'Back',
    settingsTitle: 'App installation',
    settingsDescription: 'See how to add this web app to your Home Screen or computer.',
    openGuide: 'View installation guide'
  },
  fr: {
    promotionTitle: 'Ajoutez GNEGNEGNE comme app',
    promotionBody: 'Ouvrez-la plus rapidement depuis l’écran d’accueil et recevez les notifications de planning plus facilement.',
    installNow: 'Installer l’app',
    viewGuide: 'Voir les instructions',
    later: 'Plus tard',
    alreadyInstalled: 'Déjà installée',
    installing: 'Ouverture de l’installation…',
    guideTitle: 'Installer l’app GNEGNEGNE',
    guideIntro: 'Ajoutez cette app web à votre appareil pour l’ouvrir comme une application classique.',
    iosSafariTitle: 'iPhone · Safari',
    iosSafariSteps: ['Touchez le bouton Partager dans Safari.', 'Choisissez Sur l’écran d’accueil.', 'Activez Ouvrir comme app web.', 'Touchez Ajouter en haut à droite.'],
    iosOtherNotice: 'Sur iPhone, ouvrez cette page dans Safari puis suivez les étapes ci-dessous.',
    androidTitle: 'Android · Chrome',
    androidSteps: ['Ouvrez le menu Chrome (⋮).', 'Choisissez Installer l’application ou Ajouter à l’écran d’accueil.', 'Confirmez l’installation.'],
    desktopTitle: 'Navigateur sur ordinateur',
    desktopSteps: ['Ouvrez l’icône d’installation dans la barre d’adresse ou le menu du navigateur.', 'Choisissez Installer GNEGNEGNE.', 'Confirmez l’installation.'],
    back: 'Retour',
    settingsTitle: 'Installation de l’app',
    settingsDescription: 'Découvrez comment ajouter cette app web à votre écran d’accueil ou à votre ordinateur.',
    openGuide: 'Voir le guide d’installation'
  }
};

export function getPwaInstallText(language) {
  return TEXT[language] || TEXT.ko;
}
